import { useState, useEffect } from "react";
import { doc, onSnapshot } from "firebase/firestore";
import { firestore } from "../components/firebase.config";

const forms = [
  {
    key: "a",
    step: "Step 1",
    letter: "1",
    title: "Manufacturing Facility",
    route: "form-a",
    status: "Not Started",
    progress: 0,
    updated: "Not updated yet",
    color: "#16a34a",
    bg: "#dcfce7",
  },
  {
    key: "b",
    step: "Step 2",
    letter: "2",
    title: "Source Streams",
    route: "form-b",
    status: "Not Started",
    progress: 0,
    updated: "Not updated yet",
    color: "#ea580c",
    bg: "#ffedd5",
  },
  {
    key: "c",
    step: "Step 3",
    letter: "3",
    title: "Emissions & Energy",
    route: "form-c",
    status: "Not Started",
    progress: 0,
    updated: "Not updated yet",
    color: "#7c3aed",
    bg: "#ede9fe",
  },
  {
    key: "d",
    step: "Step 4",
    letter: "4",
    title: "Production Processes",
    route: "form-d",
    status: "Not Started",
    progress: 0,
    updated: "Not updated yet",
    color: "#2563eb",
    bg: "#dbeafe",
  },
  {
    key: "e",
    step: "Step 5",
    letter: "5",
    title: "Precursors",
    route: "form-e",
    status: "Not Started",
    progress: 0,
    updated: "Not updated yet",
    color: "#d97706",
    bg: "#fef3c7",
  },
  {
    key: "f",
    step: "Step 6",
    letter: "6",
    title: "Tools & Calculations",
    route: "form-f",
    status: "Not Started",
    progress: 0,
    updated: "Not updated yet",
    color: "#0891b2",
    bg: "#cffafe",
  },
];

const getStatusFromProgress = (progress) => {
  if (progress >= 100) return "Completed";
  if (progress >= 10) return "In Progress";
  return "Not Started";
};

const formatUpdatedTime = (timestamp) => {
  if (!timestamp) return "Not updated yet";

  const date = timestamp?.toDate ? timestamp.toDate() : new Date(timestamp);

  return date.toLocaleString("en-IN", {
    day: "2-digit",
    month: "short",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
    hour12: true,
  });
};

export default function useAuditProgress(auditId) {
  const [formsData, setFormsData] = useState(forms);
  const [overallProgress, setOverallProgress] = useState(0);

  useEffect(() => {
    if (!auditId) return;

    const formKeys = ["a", "b", "c", "d", "e", "f"];

    const unsubscribers = formKeys.map((key) => {
      const ref = doc(
        firestore,
        "auditReports",
        auditId,
        `form_${key}`,
        "main",
      );

      return onSnapshot(ref, (snapshot) => {
        const formData = snapshot.exists() ? snapshot.data() : {};
        const progressMeta = formData?.progressMeta || {};

        const progress = progressMeta.progress || 0;
        const status = progressMeta.status || getStatusFromProgress(progress);
        const updated = formatUpdatedTime(formData?.updatedAt);
        const sections = progressMeta.sections || {};

        setFormsData((prevForms) => {
          let updatedForms = prevForms.map((form) =>
            form.key === key
              ? {
                  ...form,
                  progress,
                  status,
                  updated,
                  sections,
                }
              : form,
          );

          const totalProgress = updatedForms.reduce(
            (sum, form) => sum + form.progress,
            0,
          );

          setOverallProgress(Math.round(totalProgress / updatedForms.length));

          return updatedForms;
        });
      });
    });

    return () => {
      unsubscribers.forEach((unsubscribe) => unsubscribe());
    };
  }, [auditId]);

  return {
    formsData,
    overallProgress,
  };
}
